import React from "react";

export const BrandMark = ({ size = 32, className = "", testid = "brand-mark" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="CoreX" data-testid={testid} className={`shrink-0 ${className}`} style={{ filter: "drop-shadow(0 0 12px var(--color-cx-emerald-glow, rgba(16,185,129,0.35)))" }}>
    <defs><linearGradient id="cx-brand-grad" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#10B981" /><stop offset="1" stopColor="#06B6D4" /></linearGradient></defs>
    <rect width="64" height="64" rx="12" fill="url(#cx-brand-grad)" />
    <text x="32" y="33" textAnchor="middle" dominantBaseline="central" fontFamily="'JetBrains Mono', Inter, ui-monospace, monospace" fontWeight="800" fontSize="30" letterSpacing="-1.5" fill="#06080B">CX</text>
  </svg>
);
